import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RenderPageService } from 'render/services/render-page.service';
import { FragmentService } from 'shared/services/fragment-shared.service';


@Injectable()
export class RenderFragmentService extends FragmentService {

  constructor(
    private readonly renderPageService: RenderPageService
  ) {
    super();
  }

  // FIXME: the return type here should not be Observable<string>. This class incorrectly extends the superclass
  public retrieveFragment(
    slug: string,
    country?: string,
    lang?: string,
    device?: string,
    timeTravelTo?: string,
    userFlags?: string
  ): Observable<string> {
    return this.renderPageService.pageBySlug(
      slug,
      country || 'ES',
      lang,
      device,
      timeTravelTo,
      userFlags
    ) as Observable<unknown> as Observable<string>;
  }

}
